export const SITE = {
  name: "NAVYOGA",
  fullName: "NAVYOGA Yoga and Wellness Center",
  tagline: "Yoga by Navyoga",
  founder: "Dr. Rajni Ahuja",
  phoneDisplay: "+91 99332 93731",
  whatsapp: "919933293731",
  email: "rajnirashi070@gmail.com",
  instagram: "yoga_by_navyoga",
  instagramUrl: "https://www.instagram.com/yoga_by_navyoga/",
  addressLines: [
    "RGT Road, near RGT School & Radhakrishnan Temple",
    "Port Blair, Andaman and Nicobar Islands",
  ],
  mapQuery: "RGT Road, Port Blair, Andaman and Nicobar Islands",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const waLink = (message) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(message)}`;

export const THERAPIES = [
  {
    id: "yoga-therapy",
    name: "Yoga Therapy",
    tagline: "Condition-specific healing practice",
    description:
      "Personalised asana, breathwork and relaxation sequences designed around your health profile — back pain, diabetes, hypertension, thyroid imbalance, stress and more.",
    benefits: ["One-on-one assessment", "Gentle, progressive practice", "Complements your medical care"],
  },
  {
    id: "acupuncture",
    name: "Acupuncture",
    tagline: "M.D. qualified needle therapy",
    description:
      "Fine, sterile single-use needles stimulate precise points to relieve pain, calm the nervous system and support the body's own recovery response.",
    benefits: ["Drug-free pain management", "Migraine & digestive support", "Deep nervous-system relaxation"],
  },
  {
    id: "cupping-hijama",
    name: "Cupping / Hijama Therapy",
    tagline: "Traditional suction healing",
    description:
      "Traditional suction therapy that improves local circulation, releases deep muscular tension and supports the body's natural detoxification.",
    benefits: ["Relieves muscle stiffness", "Improves blood flow", "Certified Hijama practitioner"],
  },
  {
    id: "sujok",
    name: "Sujok Therapy",
    tagline: "Healing through hands & feet",
    description:
      "A Korean micro-acupuncture system using seeds, magnets and gentle pressure on correspondence points of the hands and feet — no needles needed.",
    benefits: ["Needle-free & painless", "Quick relief sessions", "Safe for all ages"],
  },
  {
    id: "colour-therapy",
    name: "Colour Therapy",
    tagline: "Balance through vibration",
    description:
      "A gentle complementary practice that uses the therapeutic qualities of colours to restore emotional and energetic balance.",
    benefits: ["Non-invasive", "Supports emotional wellbeing", "Pairs beautifully with meditation"],
  },
  {
    id: "ayurveda-naturopathy",
    name: "Ayurveda & Naturopathy",
    tagline: "Rooted in Indian wisdom",
    description:
      "Diet, lifestyle and natural-remedy guidance drawn from classical Ayurvedic and naturopathic principles, adapted to island life.",
    benefits: ["Personalised diet guidance", "Daily-routine (dinacharya) planning", "Natural, food-first remedies"],
  },
  {
    id: "cancer-rehab-yoga",
    name: "Cancer Rehabilitation Yoga",
    tagline: "Gentle recovery, with care",
    description:
      "A restorative protocol for people recovering from cancer treatment — breathwork, supported asana and yoga nidra, trained at The Yoga Institute. Always alongside your oncologist's care.",
    benefits: ["Rebuilds strength gently", "Manages fatigue & anxiety", "Taught with deep sensitivity"],
  },
  {
    id: "pranayama-mudra-meditation",
    name: "Pranayama, Mudra & Meditation",
    tagline: "Breath, gesture, stillness",
    description:
      "Classical breathing practices, healing hand gestures and guided meditation to steady the mind, improve lung capacity and deepen rest.",
    benefits: ["Reduces stress & anxiety", "Improves sleep quality", "Suitable for beginners"],
  },
];

export const BATCHES = [
  {
    id: "morning",
    name: "Morning Batch",
    time: "5:30 AM – 6:30 AM",
    days: "Monday – Friday",
    mood: "Sunrise energy",
    description:
      "Start the day with surya namaskar, classical asana and pranayama as the island wakes up. Ideal for early risers, working professionals and seniors.",
    forWhom: ["Working professionals", "Seniors & beginners", "Weight & lifestyle management"],
  },
  {
    id: "evening",
    name: "Evening Batch",
    time: "5:00 PM – 6:00 PM",
    days: "Monday – Friday",
    mood: "Unwind & restore",
    description:
      "Release the day's stress with gentle flow, deep stretching, mudra and guided meditation. Perfect after work or school, for calmer evenings and deeper sleep.",
    forWhom: ["Students & office-goers", "Stress & sleep support", "Flexibility & back care"],
  },
];

export const AWARDS = [
  {
    year: "2026",
    title: "Nominated — Yoga Therapist of the Year",
    detail: "Officially nominated by the Times of India Healing India Forum, New Delhi, acknowledging the care, purpose and thoughtfulness in fostering well-being.",
    certificate: "/awards/toi-healing-india-nomination.jpg",
    highlight: true,
  },
  {
    year: "2025",
    title: "Netaji Subhash Chandra Bose Excellence Award",
    detail: "National recognition for outstanding contribution to yoga and wellness.",
  },
  {
    year: "2024",
    title: "Atal Foundation Award",
    detail: "Honoured by the Atal Foundation for service to community health.",
  },
  {
    year: "Recognition",
    title: "Memento of Appreciation — Naval Component",
    detail: "Presented by the Andaman & Nicobar Command for wellness service to naval families.",
  },
  {
    year: "2024",
    title: "ICDS Poshan Maah Recognition",
    detail: "For nutrition and wellness awareness during National Nutrition Month.",
  },
  {
    year: "Honour",
    title: "Golden Deed Award",
    detail: "Celebrating selfless service to the island community.",
  },
];

export const GALLERY_MEDIA = [
  {
    id: "media-group-rgt",
    category: "Morning Batches",
    type: "photo",
    label: "Our Batch Family — RGT Public Vidyalaya",
    src: "/assets/gallery-group-rgt.jpg",
  },
  {
    id: "media-class-headstands",
    category: "Morning Batches",
    type: "photo",
    label: "Advanced Asana Practice — Headstand Series",
    src: "/assets/gallery-class-headstands.jpg",
  },
];

export const GALLERY_SLOTS = [
  { id: 1, category: "Morning Batches", type: "video", label: "Morning Batch — Video Slot" },
  { id: 3, category: "Wellness Camps", type: "photo", label: "Wellness Camp — Slot 1" },
  { id: 4, category: "Wellness Camps", type: "video", label: "Wellness Camp — Slot 2" },
  { id: 5, category: "Community Sessions", type: "photo", label: "Community Session — Slot 1" },
  { id: 6, category: "Community Sessions", type: "video", label: "Community Session — Slot 2" },
];

export const REAL_TESTIMONIALS = [
  {
    id: "geeta",
    name: "Geeta",
    tag: "Yoga Student",
    stars: 5,
    quote: "You never just teach yoga — you understand the person behind the practice.",
    image: "/assets/review-geeta.jpg",
  },
  {
    id: "narmada",
    name: "Narmada",
    tag: "Yoga Student",
    stars: 5,
    quote: "Your classes have helped me feel stronger, calmer, more confident, and more connected with myself.",
    image: "/assets/review-narmada.jpg",
  },
  {
    id: "komal",
    name: "Komal",
    tag: "Yoga Student",
    stars: 5,
    quote: "A true Guru can change the direction of our future. I bow to my Guru with deep respect and gratitude.",
    image: "/assets/review-komal.jpg",
  },
];

export const TESTIMONIAL_SLOTS = [
  { id: 4, tag: "Morning Batch Member" },
  { id: 5, tag: "Wellness Camp Participant" },
  { id: 6, tag: "Therapy Client" },
];
